import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { PermissionDirective } from '@shared/directives/permission.directive';

@Component({
  selector: 'app-individual-tabs',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule, PermissionDirective],
  templateUrl: './individual-tabs.component.html',
  styleUrl: './individual-tabs.component.scss',
})
export class IndividualTabsComponent implements OnInit {
  @Input() accountNumber!: string;
  @Input() incomeCategory!: string;
  accountIdTab!: string;
  setRouteUrls: string[] = [];
  cdr = inject(ChangeDetectorRef);
  router = inject(Router);

  tabs: {
    path: string;
    label: string;
    route: string;
    permission: string | string[];
    mode: 'any' | 'all';
  }[] = [];

  pathMap!: Map<
    string,
    { label: string; permission: string | string[]; mode: 'any' | 'all' }
  >;

  ngOnInit(): void {
    this.buildPathMap();
    this.initializeTabs();
  }

  private buildPathMap() {
    const isHNI = this.incomeCategory === 'HNI';

    this.pathMap = new Map()
      .set('details', {
        label: 'Details',
        permission: 'get_individual',
        mode: 'any',
      })
      .set('wallet', {
        label: 'Wallet',
        permission: isHNI
          ? ['get_transaction_by_account', 'can_view_hni_details']
          : 'get_transaction_by_account',
        mode: 'all',
      })
      .set('portfolio', {
        label: 'Portfolio',
        permission: isHNI
          ? [
              'get_delux_portfolios_stat',
              'get_delux_account_portfolios',
              'can_view_hni_details',
            ]
          : ['get_delux_portfolios_stat', 'get_delux_account_portfolios'],
        mode: 'all',
      })
      .set('orders', {
        label: 'Orders',
        permission: 'can_get_orders_by_account',
        mode: 'any',
      })
      .set('audit-log', {
        label: 'Audit logs',
        permission: 'get_account_audit_log',
        mode: 'any',
      })
      .set('rm-list', {
        label: 'Relationship Manager(s)',
        permission: 'get_account_relationship_manager-list',
        mode: 'any',
      });
  }

  private initializeTabs(): void {
    this.tabs = Array.from(this.pathMap, ([path, config]) => ({
      path,
      label: config.label,
      route: this.getRoutePath(path),
      permission: config.permission,
      mode: config.mode,
    }));
  }

  getRoutePath(path: string): string {
    const currentPath = this.router.url;
    const arr = currentPath.split('/');

    // Special handling for 'portfolio'
    if (path === 'portfolio') {
      // Find index of first occurrence of 'portfolio'
      const portfolioIndex = arr.indexOf('portfolio');

      // Slice everything before the first 'portfolio'
      const baseRoute =
        portfolioIndex > -1
          ? arr.slice(0, portfolioIndex).join('/')
          : arr.slice(0, -1).join('/');

      return `${baseRoute}/portfolio/${this.accountNumber}/portfolio/`;
    }

    // Remove '/portfolio/:accountNumber/portfolio' if it exists
    const portfolioIndex = arr.indexOf('portfolio');
    if (
      portfolioIndex !== -1 &&
      arr.length > portfolioIndex + 2 &&
      arr[portfolioIndex + 2] === 'portfolio'
    ) {
      const baseRoute = arr.slice(0, portfolioIndex).join('/');
      return `${baseRoute}/${path}`;
    }
    // Default case: replace last segment with the new path
    return currentPath.replace(`${arr[arr.length - 1]}`, path);
  }

  getCurrentMobileTab(value: string) {
    this.router.navigateByUrl(value);
  }
}
